<template>
  <div class="page flex-col">
    <div class="group_1 flex-row justify-center scaler" style="width: 760px; box-shadow: none; border-color: #d2d3d0">
      <div style="position: absolute; left: 0; right: 0" class="auth-bar">
        <span style="font-size: 25px">企业邮箱认证</span>
        <span class="close-btn">×</span>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeTab: "login",
      phone: "",
      password: "",
      agree: false,
      selectedFile: null,
    };
  },
  methods: {},
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* .scaler {
  transform-origin: top left;
  transform: scale(0.67);
} */

@media (max-width: 1600px) {
  .scaler {
    transform-origin: center;
    transform: scale(0.67);
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: center;
    transform: scale(0.8);
  }
}

.auth-bar {
  /* 背景渐变，模拟图中蓝紫渐变效果 */
  background: linear-gradient(to right, #a1b8f7, #c0a2f7);
  /* 文字颜色 */
  color: #fff;
  /* 内边距，控制内容与边框距离 */
  padding: 10px 15px;
  /* 圆角，让边框更圆润 */
  border-radius: 25px 25px 0 0;
  /* 弹性布局，让关闭按钮靠右 */
  display: flex;
  /* 主轴对齐方式，文字靠左，按钮靠右 */
  justify-content: space-between;
  /*  align-items: center; */
  /* 文字垂直居中 */
  align-items: center;
  /* 相对定位，方便关闭按钮绝对定位 */
  position: relative;
}

.close-btn {
  /* 鼠标悬浮为手型，提示可点击 */
  cursor: pointer;
  /* 右边距，调整与右侧距离 */
  margin-right: 5px;
}
</style>